'use client';

import { forwardRef, useContext } from 'react';

import { ToneIcon } from '../tone-icon';
import { ToastContext } from './context/toast.context';
import { toastIconStyles } from './styles/toast-icon.styles';
import type { ToastIconPropsInterface } from './types/toast-icon.types';

export const ToastIcon = forwardRef<SVGSVGElement, ToastIconPropsInterface>(
  (props: ToastIconPropsInterface, forwardedRef) => {
    const { tone, css: cssProp, ...rest } = props;

    const context = useContext(ToastContext);

    return (
      <ToneIcon
        data-c11n-component="Toast.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        size="md"
        tone={tone || context.tone}
        css={{ ...toastIconStyles.raw({ tone: tone || context.tone }), ...cssProp }}
        {...rest}
      />
    );
  },
);

ToastIcon.displayName = 'Toast.Icon';
